module.exports = __webpack_public_path__ + "img/img19.55b37402.svg";